import { NavigateFunction } from 'react-router-dom';
import BadgeIcon from '@mui/icons-material/Badge';

import { Products, Portfolio, Help, Profile, Logout, Crm } from '@assets/svg';
import { UserType } from '@features/api/response/User';

export const getMenuItems = (
  navigate: NavigateFunction,
  handleLogoutClick: () => void
) => {
  return [
    {
      id: 'products',
      Icon: Products,
      matchingRoutes: ['product', 'investment-get-started'],
      onClick: () => navigate('/'),
      userTypes: [
        UserType.CompanyHolder,
        UserType.NomineeAgent,
        UserType.NomineeCompanyHolder,
        UserType.User,
      ],
    },
    {
      id: 'portfolio',
      Icon: Portfolio,
      onClick: () => navigate('/portfolio'),
      userTypes: [
        UserType.CompanyHolder,
        UserType.NomineeAgent,
        UserType.NomineeCompanyHolder,
        UserType.User,
      ],
    },
    {
      id: 'agents',
      Icon: BadgeIcon,
      onClick: () => navigate('/agents'),
      userTypes: [UserType.NomineeCompanyHolder],
    },
    {
      id: 'crm',
      Icon: Crm,
      onClick: () => navigate('/crm'),
      userTypes: [UserType.NomineeAgent, UserType.NomineeCompanyHolder],
    },
    {
      id: 'helpAndSupport',
      Icon: Help,
      onClick: () => window.open('https://help.swise.com/', '_blank'),
      userTypes: [
        UserType.CompanyHolder,
        UserType.NomineeAgent,
        UserType.NomineeCompanyHolder,
        UserType.User,
      ],
    },
    {
      id: 'profile',
      Icon: Profile,
      onClick: () => navigate('/profile'),
      onlyMobile: true,
      userTypes: [
        UserType.CompanyHolder,
        UserType.NomineeAgent,
        UserType.NomineeCompanyHolder,
        UserType.User,
      ],
    },
    {
      id: 'logout',
      Icon: Logout,
      onClick: handleLogoutClick,
      onlyMobile: true,
      userTypes: [
        UserType.CompanyHolder,
        UserType.NomineeAgent,
        UserType.NomineeCompanyHolder,
        UserType.User,
      ],
    },
  ];
};
